import React, { useEffect } from 'react';
import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { RenderControl, RenderElement } from 'components/RenderHelpers';
import { withAppContext } from '@ctsu/loader';
import {
  getProtocolStatusHistory,
  getProtocolDetails
} from 'actions/protocols/protocoldetail';
import _ from 'lodash';
import {
  lSelectorGetProtDetails,
  eSelectorGetProtDetails,
  ProtocolNumSelector
} from 'selectors';
import { openModal } from 'actions/common';
import atoms from 'ctsutheme/components/atoms';
import { bindLogger } from 'helpers/BindLogger';
import { ProtocolAccess } from 'acess/ProtocolAcess';
import { Grid } from '@material-ui/core';
import { 
  CanUserAccessInfo, 
  CanUserViewMatchBox,
  CanUserEditMatchBox,
  CanUserAuditCohorts, 
  CanUserSyncCohorts, 
  CanUserEditCohorts 
} from 'appconstants/Permission';
import PropTypes from 'prop-types';
import {
  ProtocolInfo, StatusChange, PCD, Contact, PIContact, CollectIRBPostClosure, MatchBox, CohortArmContainer
} from './components';

const { Divider } = atoms;

const withConnectState = connect(
  (state, ownProps) => ({
    protocolNumber: ProtocolNumSelector(state),
    prtInfo: state.prtDetails.prtInfo,
    isLoadingPrtDetails: lSelectorGetProtDetails(state),
    iserrorPrtDetails: eSelectorGetProtDetails(state)
  }),
  dispatch => bindActionCreators(
    {
      onGetPrtStsChngHistory: getProtocolStatusHistory,
      onOpenModal: openModal,
      onGetSummary: getProtocolDetails
    },
    dispatch
  )
);

const ProtInfo = ({
  prtInfo,
  onOpenModal,
  onClickStatusHistory,
  refreshSummary,
  onUpdatePreferredProtocols,
  isLoadingPrtDetails,
  iserrorPrtDetails,
  isMultiPhase = () => null
}) => {

  useEffect(() => {
    refreshSummary();
  }, [refreshSummary]);

  return (
    
    <RenderControl
      isLoading={isLoadingPrtDetails}
      iserror={iserrorPrtDetails}
      compName="Protocol Details"
      permission={CanUserAccessInfo()}
    >
      <Grid container justify="center" spacing={4}>
        <Grid item xs={6}>
          <RenderElement access>
            <ProtocolInfo
              prtInfo={prtInfo}
              onOpenModal={onOpenModal}
              onStatusHistory={onClickStatusHistory}
              refreshSummary={refreshSummary}
            />
          </RenderElement>
        </Grid>
        <Grid item xs={6}>
          <RenderElement access>
            <StatusChange
              refreshSummary={refreshSummary}
              prtInfo={prtInfo}
              multiPhase={isMultiPhase()}
            />
          </RenderElement>
          <Divider />
          <RenderElement access>
            <PCD
              completionDates={prtInfo.completionDates}
              grpProtStatusDate={prtInfo.grpProtStatusDate}
              grpProtStatus={prtInfo.grpProtStatus}
              multiPhase={isMultiPhase()}
            />
          </RenderElement>
          <Divider />
          <RenderElement access>
            <CollectIRBPostClosure
              collectIrbApprovalPostClosure={prtInfo.isStatusCb}
            />
          </RenderElement>
          <Divider />
          <RenderElement access>
            <Contact
              contact={prtInfo.contact}
              prtId={prtInfo.prtId}
            />
          </RenderElement>
          <Divider />
          <RenderElement access>
            <PIContact
              pi={prtInfo.pi}
            />
          </RenderElement>
        </Grid>
        <Grid item xs={12}>
          <RenderElement access={CanUserViewMatchBox()}>
            <MatchBox 
              protocolNumber={prtInfo.protocolNumber}
              grpProtStatus={prtInfo.grpProtStatus}
              isMatchboxStudy={prtInfo.isMatchboxStudy}
              isTreatment={prtInfo.isTreatment}
              CanUserEditMatchBox={CanUserEditMatchBox()}
              CanUserAuditCohorts={CanUserAuditCohorts()}
              CanUserSyncCohorts={CanUserSyncCohorts()}
              CanUserEditCohorts ={CanUserEditCohorts()}
              CanUserAccessInfo={CanUserAccessInfo()}
            />
          </RenderElement>
        </Grid>
        <Grid item xs={12}>
          <RenderElement access={CanUserAccessInfo()}>
            <CohortArmContainer 
              protocolNumber={prtInfo.protocolNumber}
              CanUserAccessInfo={CanUserAccessInfo()}
            />
          </RenderElement>
        </Grid>
      </Grid>
      {prtInfo && prtInfo.leadGrp && <ProtocolAccess prtInfo={prtInfo} />}
    </RenderControl>
   
  );
};

ProtInfo.propTypes = {
  prtInfo: PropTypes.oneOfType([PropTypes.object]),
  onOpenModal: PropTypes.func,
  onClickStatusHistory: PropTypes.func,
  refreshSummary: PropTypes.func,
  onUpdatePreferredProtocols: PropTypes.func
};

ProtInfo.defaultProps = {
  prtInfo: null,
  onOpenModal: null,
  onClickStatusHistory: null,
  refreshSummary: null,
  onUpdatePreferredProtocols: null
};

export const ProtocolInfoContainer = compose(
  withConnectState,
  withAppContext,
  withHandlers({
    onClickStatusHistory: props => (event, id) => {
      const { context, onGetPrtStsChngHistory } = props;
      return bindLogger(onGetPrtStsChngHistory, context)(id);
    },
    refreshSummary: props => event => {
      const {
        context,
        onGetSummary,
        match
      } = props;

      if (match && match.params.id) bindLogger(onGetSummary, context)(match.params.id);
    },
    isMultiPhase: props => () => {
      const { prtInfo } = props;
      if (!_.isEmpty(prtInfo) && prtInfo.phase && prtInfo.phase.includes('/')) {
        return prtInfo.phase.includes('/');
      }
      return false;
    }
  })
)(ProtInfo);

export default ProtocolInfoContainer;
